const NEWSLETTER_INVESTOR_RELATIONS = 'GlobalFormNewsletterInvestorRelations'
const NEWSLETTER_PRESS_AND_MEDIA = 'GlobalFormNewsletterPressAndMedia'
const NEWSLETTER_KNOWLEDGE_HUB = 'GlobalFormNewsletterKnowledgeHub'

export default {
  newsletterInvestorRelations: NEWSLETTER_INVESTOR_RELATIONS,
  newsletterPressAndMedia: NEWSLETTER_PRESS_AND_MEDIA,
  newsletterKnowledgeHub: NEWSLETTER_KNOWLEDGE_HUB
}
